import { AxiosResponse } from 'axios';
import { ContactByCompanyRequest, ContactRequest, SupportContactRequest } from '@/main/models/request';
import { ContactResponse } from '@/main/models/response';
import { Result } from '@/main/models/common/resultResponse';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { ISupportContact } from '@/main/models/response/supportContactResponse';

export abstract class IContactApi {
  abstract getContactBodyshop(
    request: ContactRequest
  ): Promise<AxiosResponse<Result<ContactResponse[]>>>;

  abstract getContactsListByCompany(
    request: ContactByCompanyRequest
  ): Promise<AxiosResponse<Result<ContactResponse[]>>>;

  abstract getContacts(
    request: SupportContactRequest
  ): Promise<Result<PaginationResponse<ISupportContact>>>;
}
